// libraries.
import { Outlet } from 'react-router-dom';

// components.

export const PolygonsPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
